import type { ColDef, GetQuickFilterTextParams } from "ag-grid-enterprise";

// AG Grid's quick filter concatenates EVERY column's text, so typing "running" or an
// organization name matched rows the user saw no reason for. Scoping it is per-column:
// one column carries the whole searchable string — built from row-data fields, so a field
// with no column of its own (`id`) is still searchable — and every other column
// contributes the empty string.
//
// The carrier must be a visible column: quick filter skips hidden ones unless
// includeHiddenColumnsInQuickFilter is set, and these grids leave it off.
export function withQuickFilterFields(columnDefs: ColDef[], fields: string[]): ColDef[] {
  if (!fields.length || !columnDefs.length) return columnDefs;

  const carrierIndex = Math.max(
    columnDefs.findIndex((col) => col.hide !== true),
    0
  );

  return columnDefs.map((col, index) => ({
    ...col,
    getQuickFilterText:
      index === carrierIndex
        ? (params: GetQuickFilterTextParams) =>
            fields
              .map((field) => (params.data as Record<string, unknown> | undefined)?.[field] ?? "")
              .join(" ")
        : () => "",
  }));
}
